import { type FC, useContext } from "react";

import { Link, Section, Text } from "@alpacahq/ui/old";

import { AppDetailsContext } from "./AppDetailsPage";

export const AppDetailsPermissions: FC = () => {
  const {
    client: { name, terms_of_use, privacy_policy },
  } = useContext(AppDetailsContext);

  return (
    <Section title="Permissions">
      <Text className="mb-1 text-md">
        {name} requires access to your entire portfolio
      </Text>
      <Text className="text-md">{name} can place trades on your behalf</Text>
      <Text className="mt-6 space-x-2 text-md">
        <Link onClick={() => window.open(terms_of_use, "_blank")}>
          Terms of Use
        </Link>
        <Link onClick={() => window.open(privacy_policy, "_blank")}>
          Privacy Policy
        </Link>
      </Text>
    </Section>
  );
};
